// <s-scent-finder> joins the "mood" (scent-family tag) and "who" (men / women tag) choices
// and opens the all-products collection filtered by those tags.
// Without JS the form submits the mood term to product search.
class SScentFinder extends HTMLElement {
  #controller;

  connectedCallback() {
    const form = this.querySelector('form');
    if (!form) return;

    this.#controller = new AbortController();
    form.addEventListener('submit', (event) => {
      const mood = form.querySelector('input[name="q"]:checked');
      if (!mood || !form.dataset.tagBase) return;
      event.preventDefault();

      const who = form.querySelector('input[name="who"]:checked');
      const tags = [mood.value, who?.dataset.term].filter(Boolean);
      window.location.assign(`${form.dataset.tagBase}/${tags.map(encodeURIComponent).join('+')}`);
    }, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-scent-finder')) customElements.define('s-scent-finder', SScentFinder);
